export default "__VITE_ASSET__WmuCWC5K__"